import React from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import DEV from "../img/webDev.png";
import DES from "../img/webDeS.png";
import DB from "../img/webDB.png";
import DD from "../img/DES2.png";
import { Mobile, Landscape } from "../Response";
const I_DO = () => {
  const back = useSelector((state) => state.switch.back);
  return (
    <Container back={back}>
      <Wrap>
        <Title back={back}>My Servieces</Title>
        {/* <TextDESC>I WILL MAKE YOUR THING DO WELL LOOK GOOD</TextDESC> */}
        <List>
          <Item back={back}>
            <Image src={DEV} />
            <Desc>
              <ItemTitle back={back}>WEB DEVELOPMENT</ItemTitle>
              <TextDESC back={back}>
                I'm willing to develop and build a scalable and Full Functional
                Web applicatin for you with the newest Technology
              </TextDESC>
            </Desc>
          </Item>

          <Item back={back}>
            <Image src={DES} />
            <Desc>
              <ItemTitle back={back}>WEB DESIGN</ItemTitle>
              <TextDESC back={back}>
                I can design for your Website or your Mobile App ,I asure you
                that your clients will be intrested in your App
              </TextDESC>
            </Desc>
          </Item>

          <Item back={back}>
            <Image src={DB} />
            <Desc>
              <ItemTitle back={back}>DATABASES</ItemTitle>
              <TextDESC back={back}>
                I develop & build a really scalable Database for you and your
                business,with both (SQL & NOSQL)Databases
              </TextDESC>
            </Desc>
          </Item>

          <Item back={back}>
            <Image src={DD} />
            <Desc>
              <ItemTitle back={back}>GRAPHIC DESIGN</ItemTitle>
              <TextDESC back={back}>
                I will create a suitable and high quality design for your
                products,I design new Logo and Product for your startUp company
              </TextDESC>
            </Desc>
          </Item>
        </List>
      </Wrap>
    </Container>
  );
};

export default I_DO;

const Container = styled.div`
  overflow: hidden;
  max-width: 100vw;
  // width: 50%;
  height: 100vh;
  margin: 120px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  // background: red;

  background: ${(props) =>
    props.back === "sun" ? "#f9fdff" : "rgb(22, 28, 35,0.3)"};

  ${Mobile({ margin: "10px 0px", height: "65vh", margin: "50px 0px 30px 0px" })}
  ${Landscape({
    height: "140vh",
    width: "100%",
    margin: "20px 0px 10px 0px",
    padding: 20,
  })}
`;

const Wrap = styled.div`
  overflow: hidden;
  // background: gray;
  width: 56%;
  height: 95%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  ${Mobile({ border: "none", width: "97%", height: "95%", gap: 15 })}
  ${Landscape({
    height: "95%",
    width: "80%",
    gap: 3,
  })}
`;
const Title = styled.h1`
  color: ${(props) =>
    props.back === "sun" ? "#929292" : " rgba(228, 236, 240, 0.7)"};
  height: 6%;
  ${Mobile({ height: "4%", fontSize: 18, fontWeight: 600 })}
  ${Landscape({
    height: "3%",

    margin: 15,
  })}
`;
const List = styled.div`
  height: 90%;
  width: 100%;
  // background: red;
  display: flex;
  justify-content: CENTER;
  align-items: center;
  //  gap:60px;
  flex-wrap: wrap;
  ${Mobile({
    height: "95%",
    width: "87%",
    justifyContent: "space-around",
    alignItems: "space-around",
  })}
  ${Landscape({
    height: "100%",
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
  })}
`;
const Item = styled.div`
  overflow: hidden;
  margin: 48px;
  padding: 14px 20px;
  width: 30%;
  height: 40%;

  background: ${(props) =>
    props.back === "sun" ? "#fcfeff" : "rgba(26, 32, 39,0.8)"};

  border-radius: 20px;

  box-shadow: ${(props) =>
    props.back === "sun" && " 0px 5px 9px 0px rgba(143, 166, 168, 0.2)"};

  // border: 3px solid  rgba(40, 44, 52,0.2);

  border: 3px solid
    ${(props) =>
      props.back === "sun"
        ? "rgba(143, 166, 168, 0.2)"
        : "rgba(143, 166, 168, 0.1)"};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: all 1s;
  gap: 18px;
  &:hover {
    transform: scale(1.1);
  }
  ${Mobile({
    margin: "10px",
    width: "42%",
    borderRadius: "10px",
    gap: 7,
    height: "45%",
    padding: "2px 5px",
    border: "1.5px solid rgba(143, 166, 168, 0.2)",
  })}
  ${Landscape({
    margin: "20px",
    width: "30%",
    gap: 3,
    height: "40%",
    borderRadius: "10px",
    padding: "2px 5px",
    border: "1.5px solid rgba(143, 166, 168, 0.2)",
  })}
`;
const Image = styled.img`
  flex: 1;
  width: 62%;
  height: 62%;
`;
const Desc = styled.div`
  flex: 4;

  display: flex;
  flex-direction: column;
  justify-content: FLEX-START;
  gap: 5px;
  align-items: center;
  ${Landscape({
    flex: 3,
  })}
`;
const ItemTitle = styled.h4`
  // align-self: flex-start;

  font-size: 18px;

  color: ${(props) =>
    props.back === "sun" ? "#747474" : " rgba(228, 236, 240, 0.9)"};
  ${Mobile({ fontSize: 12 })}
  ${Landscape({ fontSize: 16 })}
`;

const TextDESC = styled.h5`
  line-height: 1.2;

  color: ${(props) =>
    props.back === "sun" ? "#929292" : " rgba(228, 236, 240, 0.7)"};
  font-size: 17px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  // gap: 20px;
  align-items: center;
  font-weight: 400;
  text-align: start;
  margin-top: 4px;
  text-align: center;
  ${Mobile({ fontSize: 12, lineHeight: 1, fontWeight: 500 })}
  ${Landscape({ fontSize: 12, lineHeight: 1, fontWeight: 400 })}
`;
